import React from 'react';
import './App.css';
import './styles/auth-theme.css';
import { AuthProvider, useAuth } from './auth/AuthContext.js';
import { AuthPage } from './pages/AuthPage.js';
import { DashboardPage } from './pages/DashboardPage.js';
import { CliLoginCallback } from './pages/CliLoginCallback.js';
import { LogoutPage } from './pages/LogoutPage.js';

function AppContent(): React.JSX.Element {
  const { isAuthenticated, isLoading, user, signOut, currentPage, cliLoginParams, idToken } = useAuth();

  if (window.location.pathname === '/logout') {
    return <LogoutPage />;
  }

  if (isLoading) {
    return <div />;
  }

  if (!isAuthenticated) {
    return <AuthPage />;
  }

  if (currentPage === 'cli-callback' && cliLoginParams && idToken) {
    return <CliLoginCallback idToken={idToken} port={cliLoginParams.port} state={cliLoginParams.state} />;
  }

  if (user) {
    return <DashboardPage email={user.email} onSignOut={() => void signOut()} />;
  }

  throw new Error('Authenticated but no user object available');
}

export function App(): React.JSX.Element {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
